import { IAccountsPayable } from "@nkr/models/reports/accounts-payable";
import { DropdownButton, MenuItem } from "react-bootstrap";

type TProps = {
    ap:IAccountsPayable
    onUpdateAchInfo:(ap:IAccountsPayable) => void
};

export default function ActionsButton({ ap, onUpdateAchInfo }: TProps) {
    
    const enableUpdateACH = (ap.compAchRoutingNumber && ap.compAchRoutingNumber !== ap.achRoutingNumber)
        || (ap.compAchAccountNumber && ap.compAchAccountNumber !== ap.achAccountNumber);
    
    return (
        <DropdownButton title="Actions" bsSize="xs" bsStyle="primary" id={`ap-actions-${ap.centerId}`} pullRight>
            {<MenuItem disabled={!enableUpdateACH} onClick={() => onUpdateAchInfo(ap)}>Update ACH Information</MenuItem>}
        </DropdownButton>
    );
}